import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "panel"]
  static values = { active: String }

  connect() {
    if (!this.activeValue) this.activeValue = "board"
    this.showActiveView()
  }

  switch(event) {
    this.activateView(event.currentTarget.dataset.view)
  }

  keydown(event) {
    const keys = ["ArrowLeft", "ArrowRight", "Home", "End"]
    if (!keys.includes(event.key)) return

    event.preventDefault()

    const currentIndex = this.buttonTargets.indexOf(event.currentTarget)
    if (currentIndex < 0) return

    let nextIndex = currentIndex

    if (event.key === "ArrowRight") nextIndex = (currentIndex + 1) % this.buttonTargets.length
    if (event.key === "ArrowLeft") nextIndex = (currentIndex - 1 + this.buttonTargets.length) % this.buttonTargets.length
    if (event.key === "Home") nextIndex = 0
    if (event.key === "End") nextIndex = this.buttonTargets.length - 1

    const nextButton = this.buttonTargets[nextIndex]
    this.activateView(nextButton.dataset.view)
    nextButton.focus()
  }

  activateView(view) {
    this.activeValue = view
    this.showActiveView()
  }

  showActiveView() {
    this.buttonTargets.forEach((button) => {
      const active = button.dataset.view === this.activeValue
      button.classList.toggle("is-active", active)
      button.setAttribute("aria-selected", active ? "true" : "false")
      button.setAttribute("tabindex", active ? "0" : "-1")
    })

    this.panelTargets.forEach((panel) => {
      const active = panel.dataset.view === this.activeValue
      panel.hidden = !active
    })
  }
}
